/**
 * Runtime configuration reader.
 * Values come from /config.js (loaded via <script> in index.html).
 * Falls back to REACT_APP_* env vars for backwards compatibility during dev.
 */
const runtimeConfig = window.__RUNTIME_CONFIG__ || {};

export const BACKEND_URL =
  runtimeConfig.BACKEND_URL || process.env.REACT_APP_BACKEND_URL || "http://localhost:8001";
